module.exports = __webpack_public_path__ + "img/refund.7fefcadb.svg";